import { Link } from "react-router-dom";
import { ChevronDown, Clapperboard, Copy, Megaphone } from "lucide-react";
import { useAuth } from "@/components/auth/AuthProvider";
import { useAuthModal } from "@/store/useAuthModal";

const capabilities = [
  {
    name: "Agentic Adclone",
    desc: "Clone winning ads in minutes",
    href: "/capabilities/ad-cloning",
    icon: Copy,
  },
  {
    name: "Campaign Management",
    desc: "Autonomous Meta & Google ops",
    href: "/capabilities/campaign-management",
    icon: Megaphone,
  },
  {
    name: "Creative Studio",
    desc: "End-to-end product creative",
    href: "/capabilities/creative-studio",
    icon: Clapperboard,
  },
];

const appEntryPath = "/explore";

export function MarketingNav() {
  const { data: session, isPending } = useAuth();
  const isLoggedIn = Boolean(session?.user);

  return (
    <div className="auralis-home pointer-events-none fixed top-0 z-50 flex w-full justify-center px-4 pt-6">
      <nav className="pointer-events-auto flex w-full max-w-5xl items-center justify-between rounded-glass border border-glass-border/50 bg-white/40 px-6 py-4 shadow-ambient-lg backdrop-blur-[20px] transition-all duration-300">
        <Link to="/" className="flex items-center gap-3 text-[20px] font-medium text-foreground">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-foreground">
            <div className="h-3 w-3 rounded-full bg-background" />
          </div>
          <span>WiserStudio</span>
        </Link>
        <div className="flex items-center gap-8">
          <div className="relative group hidden md:block">
            <button className="flex items-center gap-1.5 py-2 text-[14px] font-medium uppercase text-muted-foreground transition-colors hover:text-foreground">
              Capabilities
              <ChevronDown className="w-3.5 h-3.5 transition-transform duration-200 group-hover:rotate-180" />
            </button>
            <div className="invisible absolute left-1/2 top-full mt-4 w-72 max-w-screen-safe -translate-x-1/2 rounded-glass border border-glass-border bg-surface-low/90 p-3 opacity-0 shadow-ambient-lg backdrop-blur-[30px] transition-all duration-300 group-hover:visible group-hover:opacity-100">
              {capabilities.map((cap) => (
                <Link
                  key={cap.href}
                  to={cap.href}
                  className="flex items-center gap-4 rounded-md px-4 py-3 text-muted-foreground transition-all hover:bg-white hover:text-foreground hover:shadow-ambient"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-white shadow-ambient">
                    <cap.icon className="h-4 w-4 text-foreground" />
                  </span>
                  <div className="min-w-0">
                    <p className="text-[14px] font-medium leading-tight text-foreground">
                      {cap.name}
                    </p>
                    <p className="ds-caption mt-1 truncate text-outline">
                      {cap.desc}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div className="flex items-center gap-3">
            {isPending ? (
              <div
                className="h-10 w-28 shrink-0 animate-pulse rounded-full bg-surface-high"
                aria-hidden
              />
            ) : isLoggedIn ? (
              <Link
                to={appEntryPath}
                className="rounded-full bg-foreground px-6 py-3 text-[14px] font-medium text-primary-foreground shadow-ambient transition-colors hover:bg-inverse-surface"
              >
                Open Studio
              </Link>
            ) : (
              <>
                <button
                  type="button"
                  onClick={() => useAuthModal.getState().openLogin()}
                  className="hidden px-4 py-3 text-[14px] font-medium text-muted-foreground transition-colors hover:text-foreground md:block"
                >
                  Log in
                </button>
                <button
                  type="button"
                  onClick={() => useAuthModal.getState().openSignup()}
                  className="rounded-full bg-foreground px-6 py-3 text-[14px] font-medium text-primary-foreground shadow-ambient transition-colors hover:bg-inverse-surface"
                >
                  Get Started
                </button>
              </>
            )}
          </div>
        </div>
      </nav>
    </div>
  );
}
